import { RouteRecordRaw } from 'vue-router'

import Home from '@/popup/components/views/Home/Home.vue'
import EditProfile from '@/popup/components/views/Home/EditProfile/EditProfile.vue'
import ControllerDetail from '@/popup/components/views/Home/ControllerDetail/ControllerDetail.vue'
import ActivityDetail from '@/popup/components/views/Home/ActivityDetail/ActivityDetail.vue'
import ExpandedProfile from '@/popup/components/views/Home/ExpandedProfile/ExpandedProfile.vue'
import Settings from '@/popup/components/views/Home/Settings/Settings.vue'
import AddNetwork from '@/popup/components/views/Home/Settings/Network/Network/AddNetwork.vue'
import ListRelayer from '@/popup/components/views/Home/Settings/Network/Relayer/ListRelayer.vue'
import AddRelayer from '@/popup/components/views/Home/Settings/Network/Relayer/AddRelayer.vue'
import ChangePasswordFrame from '@/popup/components/views/Home/Settings/ChangePassword/ChangePasswordFrame.vue'
import changePasswordRoutes from '@/popup/components/views/Home/Settings/ChangePassword/changePasswordRoutes'

const mainRoutes: RouteRecordRaw[] = [
  { path: '', name: 'home', component: Home },
  { path: '/editProfile', name: 'edit-profile', component: EditProfile },
  {
    path: '/activityDetail/:txId',
    name: 'activityDetail',
    component: ActivityDetail,
    props: true,
  },
  {
    path: '/controllerDetail/:controllerAddress',
    name: 'controllerDetail',
    component: ControllerDetail,
  },
  { path: '/expanded', name: 'expanded', component: ExpandedProfile },
  { path: '/settings', name: 'settings', component: Settings },
  {
    path: '/settings/network/:networkId?',
    name: 'network',
    component: AddNetwork,
  },
  {
    path: '/settings/relayer/list',
    name: 'listRelayer',
    component: ListRelayer,
  },
  {
    path: '/settings/relayer/add',
    name: 'addRelayer',
    component: AddRelayer,
  },
  {
    path: '/settings/relayer/edit/:relayerId?',
    name: 'editRelayer',
    component: AddRelayer,
  },
  {
    path: '/settings/password/change',
    name: 'changePassword',
    component: ChangePasswordFrame,
    children: changePasswordRoutes,
  },
]

export default mainRoutes
